<template>
	<div class="socials" :class="theme">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:aria-label="medium.platform"
			:href="medium.url"
			target="_blank"
		>
			<font-awesome-icon v-if="medium.platform == 'twitter'" icon="fa-brands fa-x-twitter" size="1x" />
			<font-awesome-icon
				v-else-if="!['tripadvisor', 'zoover'].includes(medium.platform)"
				:icon="`fa-brands fa-${medium.platform}`"
				size="1x"
			/>
		</a>
	</div>
</template>

<script setup>
defineProps({
	theme: { type: String, default: 'dark' },
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-small-white.png') no-repeat center center;
	background-size: 22px;
	width: 50px;
	height: 50px;
	line-height: 50px;
}

.socials {
	a {
		text-align: center;
		font-size: 26px;
		text-decoration: none;
		color: #fff;
		display: inline-block;
		margin: 6px 12px 6px 0;

		&:hover {
			color: var(--primary-color);
		}
	}

	&.light a {
		color: var(--primary-text-color);
		border-color: #ccc;

		&:hover {
			border-color: #999;
			color: var(--primary-color);
		}
	}
}
</style>
